<template>
  <div
    class="export-top-bar"
  >
    <div
      class="_top"
    >
      <div class="_meta">
        <div class="_date">
          {{ date }}
        </div>
        <div
          v-if="companyName"
          class="_company"
        >
          {{ companyName }}
        </div>
      </div>
      <div class="_main">
        <div class="_left">
          <h1
            v-if="icons && icons.length > 0"
            class="_title"
          >
            <item-title
              :icons="icons"
              :title="title"
              wrap-title
            />
          </h1>
          <h1
            v-else
            class="_title"
          >
            {{ title }}
          </h1>
        </div>
        <img
          src="/img/icons/mooncamp-logo.svg"
        >
      </div>
    </div>
    <hr
      class="_divider"
    >
  </div>
</template>

<script setup>
import ItemTitle from '@/components/ItemTitle.vue';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import { DateTime } from 'luxon';
import { computed } from 'vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  icons: {
    type: Array,
    default: () => [],
  },
});

const { loggedInUserAccount } = useLoggedInUserAccount();
const companyName = computed(() => loggedInUserAccount.value.companyName || '');
const date = DateTime.local().toLocaleString(DateTime.DATETIME_SHORT);

</script>

<style scoped lang="scss">
.export-top-bar {
  margin: 1rem;

  ._top {
    padding-top: .6rem;

    ._meta {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: .4rem;
      font-size: 14px;
      color: map_get($grey, 'darken-1');

      ._company {
        padding-left: 1rem;
        margin-left: 1rem;
        border-left: 1px solid map_get($grey, 'lighten-3');
      }
    }

    ._main {
      display: flex;
      align-items: center;
      justify-content: space-between;

      ._left {
        max-width: 66%;

        ._title {
          font-size: 30px;
          margin: 0;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  ._divider {
    margin-top: .6rem;
    margin-bottom: 3rem;
    border: 1px solid map_get($grey, 'lighten-4');
  }
}
</style>
